import { Reveal } from "./Reveal";
import { useLanguage } from "@/i18n";

export default function Stats() {
    const { t } = useLanguage();

    return (
        <section data-testid="stats-section" className="bg-[#081627]">
            <div className="mx-auto grid max-w-7xl grid-cols-2 gap-y-12 px-6 py-16 lg:grid-cols-4 lg:px-10 lg:py-20">
                {t.stats.items.map((s, i) => (
                    <Reveal key={s.label} delay={i * 0.06}>
                        <div data-testid={`stat-${i + 1}`} className="border-l border-[#1E4266] pl-6">
                            <p className="font-display text-3xl font-bold tracking-tight text-white sm:text-4xl lg:text-5xl">
                                {s.value}
                            </p>
                            <p className="mt-3 font-mono text-[11px] uppercase tracking-[0.2em] text-[#5B8DEF]">
                                {s.label}
                            </p>
                        </div>
                    </Reveal>
                ))}
            </div>
        </section>
    );
}
